/**
 * ...
 * @author Fred Pinn
 */
/**
 * package: com.inq.ui
 * class: ClientBody
 * @extends com.inq.ui.Container 
 * @constructor
 */
com.inq.ui.ClientBody = function() {
	//We need to init com.inq.ui.Container with our instance element id but we have none.
	//Pass our element "window.parent.document.body" via overridden determineExistingElement method
	com.inq.ui.Container.call(this, null, null, window.parent.document);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.ClientBody, "com.inq.ui.ClientBody");

/**
 * Public override function to properly use our target element and NOT id!
 *
 * @override
 * @param {string} _id
 * @return {HTMLElement}
 */
com.inq.ui.ClientBody.prototype.determineExistingElement = function(_id){
 	return window.parent.document.body;
};

/**
 * closeAll
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function closeAll()
 * @public
 * @static
 * @return {void}
 */
com.inq.ui.ClientBody.closeAll = function() {
	/** @type {Array} */
	var keyz = Reflect.fields(com.inq.ui.ClientBody._collection);
	var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = keyz.length;
	while(_g1 < _g) {
		var /** @type {number} */ ix = _g1++;
		var /** @type {string} */ k = "" + keyz[ix];
		/** @type {com.inq.ui.Html} */
		var element = com.inq.ui.ClientBody._collection[k];
		if(element._div.id != null && element._div.id.indexOf("tcChat_") == 0) {
			element.removeFromBody();
			com.inq.ui.ClientBody._collection[k] = null;
		}
	}
};


/**
 * registerElement
 *
 * $type TFun([{ name => element, t => TInst(com.inq.ui.Html,[]), opt => false }],TEnum(Void,[]))
 * public static function registerElement(element:Html)
 * @public
 * @static
 * @param {com.inq.ui.Html}  element 
 * @return {void}
 */
com.inq.ui.ClientBody.registerElement = function(element) {
	/** @type {?string} */
	var id = element.getID();
	if(id == null) {
		id = "inq_" + Math.round(Math.random() * 3141593);
		element.setID(id);
	}
	if(element != null) com.inq.ui.ClientBody._collection[id] = element;
};


/**
 * getElement
 *
 * $type TFun([{ name => id, t => TInst(String,[]), opt => false }],TInst(com.inq.ui.Html,[]))
 * public static function getElement(id:String)
 * @public
 * @static
 * @param {string}  id 
 * @return {com.inq.ui.Html}
 */
com.inq.ui.ClientBody.getElement = function(id) {
	return com.inq.ui.ClientBody._collection[id];
};


/**
 * resize
 *
 * $type TFun([],TEnum(Void,[]))
 * public override function resize()
 * @override
 * @public
 * @this com.inq.ui.ClientBody
 * @return {void}
 */
com.inq.ui.ClientBody.prototype.resize = function() {
};

com.inq.ui.ClientBody.prototype.cleanUp = function () {
	com.inq.ui.ClientBody._collection = new com.inq.utils.Dictionary();
};
/** @type {com.inq.ui.ClientBody} */
com.inq.ui.ClientBody.prototype.__class__ = com.inq.ui.ClientBody;
/** @private @type {com.inq.utils.Dictionary} */
com.inq.ui.ClientBody._collection = new com.inq.utils.Dictionary();

